module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ci-alert"
  }, [_c('h1', [_vm._v("404 NOT FOUND")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7d251090"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ci-components/components/notFound.vue
// module id = 259
// module chunks = 4